// getters are functions like computed
export default {
    user(state, getters, rootState) {
        return getters['account/user']
    },
    userIsLoggedIn(state, getters, rootState) {
        return getters['account/isLoggedIn'];
    },
    urls(state, getters, rootState) {
        return state.global.urls;
    },
    global(state, getters, rootState) {
        return state.global;
    },
}